<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="home-1">
      <div>Join the short play journey and let creativity bloom in the collision</div>
      <p>Your opinions will become our source of inspiration and light up every scene! The charm of short plays shines brightly because of you and me!</p>
    </div>
    <div class="home-2">
      <img src="../assets/home_2.png" alt="">
      <div class="text-box">
        <div class="title">Provide you with professional technical services</div>
        <div class="sbtitle">Creative Chroma Advertising is committed to providing you with innovative advertising promotion, excellent technical services and comprehensive short drama product solutions. Our professional team will help your products become known throughout the Dubai market. Plus forward-looking technical services help you solve technical problems that trouble you, and provide a variety of short dramas to meet your needs.</div>
        <div class="list-box">
          <div class="item-box">
            <img src="../assets/home_3.png" alt="">
            <p>Featured innovative solutions</p>
          </div>
          <div class="item-box">
            <img src="../assets/home_4.png" alt="">
            <p>Professional technical team</p>
          </div>
          <div class="item-box">
            <img src="../assets/home_3.png" alt="">
            <p>Diverse themes and styles</p>
          </div>
        </div>
      </div>
    </div>

    <div class="home-3">
      <!-- <div class="sbtitle">Our Features</div> -->
      <div class="title">Our Features</div>
      <div class="work-box">
        <div class="work-item">
          <div>High quality work</div>
          <p>We pay attention to details and strive for excellence to ensure that our work meets customer satisfaction.</p>
        </div>
        <div class="work-item">
          <div>Diverse themes and styles</div>
          <p>The short plays we produce cover a variety of themes and styles, including suspense, comedy, romance, science fiction, etc., and can meet the needs of different customer groups.</p>
        </div>
        <div class="work-item">
          <div>Quick response and flexibility</div>
          <p>We are able to quickly respond to customer needs and flexibly adjust plans to ensure that the final work meets customer expectations.</p>
        </div>
      </div>
    </div>

    <div class="home-4">
      <div class="sbtitle">Rich content</div>
      <div class="title">Create with heart, perform with emotion, and touch your heart with art.</div>
      <div class="img-box">
        <img src="../assets/1.png" alt="">
        <img src="../assets/2.png" alt="">
        <img src="../assets/3.png" alt="">
      </div>
    </div>


    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style lang="less" scoped>
.home-1 {
  background: url(../assets/home_1.png);
  height: 700px;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    font-weight: bold;
    font-size: 52px;
    color: #FFFFFF;
    width: 900px;
    text-align: center;
  }

  p {
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
    margin-top: 30px;
    width: 900px;
    text-align: center;
  }
}

.home-2 {
  padding: 150px 360px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    width: 498px;
  }

  .text-box {
    margin-left: 20px;
    width: 670px;

    .title {
      font-weight: bold;
      font-size: 36px;
      color: #37393F;
    }

    .sbtitle {
      font-weight: 400;
      font-size: 18px;
      color: #7D7D7D;
      margin-top: 14px;
    }

    .list-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 28px;

      .item-box {
        padding: 20px;
        border: 1px solid #7D7D7D;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 10px;

        img {
          width: 39px;
        }

        p {
          font-weight: 400;
          font-size: 14px;
          color: #7D7D7D;
          margin-top: 14px;
          text-align: center;
          width: 150px;
        }
      }
    }
  }
}

.home-3 {
  padding: 80px 360px;
  background: #F2F2F2;

  .sbtitle {
    font-weight: 500;
    font-size: 26px;
    color: #FF015A;
    text-align: center;
  }

  .title {
    font-weight: bold;
    font-size: 46px;
    color: #333333;
    text-align: center;
    margin-top: 12px;
  }

  .work-box {
    margin-top: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .work-item {
      padding: 40px;
      background: #FFFFFF;
      width: 300px;
      height: 200px;

      div {
        font-weight: 600;
        font-size: 24px;
        color: #333333;
      }

      p {
        font-weight: 400;
        font-size: 17px;
        color: #999999;
        margin-top: 14px;
      }
    }
  }
}

.home-4 {
  padding: 150px 360px;

  .sbtitle {
    font-weight: 500;
    font-size: 26px;
    color: #FF015A;
  }

  .title {
    font-weight: bold;
    font-size: 46px;
    color: #37393F;
    margin-top: 16px;
  }

  .img-box {
    margin-top: 55px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 325px;
    }
  }
}
</style>
